// Campaigns list page (CHG-1236 / ITER-3359; wizard trigger added CHG-1247).
//
// Thin per the v7 brief: page files ≤30 LOC, all configuration in
// @generated/screens. Future generator regenerates campaignListConfig from
// campaign.entity-hint.yaml (CHG-1228) without touching this file.
//
// CHG-1247 addition: floating "New campaign" trigger button + conditional
// CampaignCreateWizard mount. Additive only — ListPage + campaign-list
// config UNCHANGED.
//
// Spec: specs/tier-05-experience/campaigns-v2.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { campaignListConfig } from "../generated/screens/campaign-list";
import { CampaignCreateWizard } from "../wizards/campaign-create.generated";
import { WizardTriggerButton } from "../wizards/WizardTriggerButton";
import { useWizard } from "../wizards/useWizard";
import { wizardRegistry } from "../wizards/wizardRegistry";

export function Campaigns() {
  const wizard = useWizard("campaign-create");
  return (
    <>
      <ListPage config={campaignListConfig} />
      <WizardTriggerButton
        label="New campaign"
        onClick={wizard.open}
        requirePermission={wizardRegistry["campaign-create"].manifest.trigger.permission}
        testId="trigger-campaign-create"
      />
      <CampaignCreateWizard open={wizard.isOpen} onClose={wizard.close} />
    </>
  );
}
